<template>
  <div class="rm-screen">
    <div v-if="isRange" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-calendar-today</v-icon>
      {{ $t("daily_report") }}
    </div>

    <!-- Firma nije izabrana: izbor firme (Naručeno se čita po jednoj firmi), kao u "Radnici" -->
    <template v-else-if="!selectedCompany">
      <p class="rm-muted rm-emp__hint">{{ $t("report_mobile.employees_pick_company") }}</p>
      <ul v-if="companies.length" class="rm-list rm-card">
        <li v-for="company in companies" :key="company.id" class="rm-emp__company">
          <button type="button" class="rm-emp__company-btn" @click="pickCompany(company)">
            <span class="rm-emp__company-name">{{ toLatin(company.name) }}</span>
            <v-icon size="18" color="#8a817a">mdi-chevron-right</v-icon>
          </button>
        </li>
      </ul>
      <div v-else class="rm-empty">
        <v-icon size="40" color="#8a817a">mdi-domain</v-icon>
        {{ $t("no_companies_selected") }}
      </div>
    </template>

    <div v-else-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!groups.length" class="rm-empty">
      {{ emptyTitle }}
      <span v-if="emptyText" class="rm-muted">{{ emptyText }}</span>
    </div>

    <template v-else>
      <div class="rm-stats rm-stats--pair">
        <div class="rm-stat rm-stat--inverse">
          <span class="rm-stat__label">{{ $t("report_desktop.workers") }}</span>
          <span class="rm-stat__value rm-num">{{ workerTotal }}</span>
        </div>
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("report_desktop.total_meals") }}</span>
          <span class="rm-stat__value rm-num">{{ mealTotal }}</span>
        </div>
      </div>

      <section v-for="group in groups" :key="group.id" class="rm-ord-group">
        <div class="rm-ord-group__head">
          <report-shift-tag :shift="group.id" long></report-shift-tag>
          <i class="rm-ord-group__rule"></i>
          <span class="rm-num">{{ groupSummary(group) }}</span>
        </div>

        <ul class="rm-list rm-card">
          <li v-for="slip in group.slips" :key="slip.key" class="rm-ord-row" :data-shift="group.id">
            <span class="rm-avatar rm-avatar--lg">{{ slip.initials }}</span>
            <div class="rm-ord-row__body">
              <div class="rm-ord-row__top">
                <span class="rm-ord-row__name">{{ slip.name }}</span>
                <span v-if="slip.orderId" class="rm-ord-row__no rm-num">#{{ slip.orderId }}</span>
              </div>
              <div v-for="(meal, index) in slip.meals" :key="index" class="rm-ord-row__meal">
                <b class="rm-num">{{ meal.total }}× </b>
                <span>{{ meal.name }}</span>
              </div>
            </div>
          </li>
        </ul>
      </section>
    </template>
  </div>
</template>

<script>
import ReportMealsTabOrders from "@/components/report/meals/tabs/ReportMealsTabOrders.vue";
import hasOrderSlips from "../../shared/hasOrderSlips";
import hasShiftSubtitle from "../../shared/hasShiftSubtitle";
import ReportShiftTag from "../../shared/ReportShiftTag.vue";

/**
 * Mobilni prikaz "Naručeno": jedna firma, po smenama spisak radnika sa njihovim obrocima. Firma, smene i
 * period se biraju u zaglavlju (kao u ostalim izveštajima), pretraga u lupi. Nasleđuje učitavanje, pretragu,
 * štampu i Excel iz ReportMealsTabOrders; podela po smenama je u hasOrderSlips.
 */
export default {
  name: "ReportMobileOrdered",
  extends: ReportMealsTabOrders,
  mixins: [hasOrderSlips, hasShiftSubtitle],
  components: { ReportShiftTag },
  computed: {
    companies() {
      return this.$store.state.report.mealCompanies || [];
    },
  },
  methods: {
    pickCompany(company) {
      this.$store.commit("report/SET_SELECTED_MEAL_COMPANY", company);
    },
  },
};
</script>

<style lang="scss">
.rm-ord-group {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__head {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 4px 0;
    font-size: 13px;
    font-weight: 600;
    color: var(--rm-muted);
  }

  &__rule {
    flex: 1;
    height: 1px;
    background: var(--rm-divider);
  }
}

.rm-ord-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--rm-divider-soft);

  &:last-child {
    border-bottom: none;
  }

  &__body {
    flex: 1;
    min-width: 0;
  }

  &__top {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
  }

  &__name {
    min-width: 0;
    font-size: 15px;
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  &__no {
    flex: none;
    font-size: 12px;
    color: var(--rm-muted);
  }

  &__meal {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin-top: 3px;
    font-size: 14px;
    line-height: 1.35;
    overflow-wrap: anywhere;

    b {
      flex: none;
      font-weight: 700;
    }
  }
}

@for $n from 1 through 4 {
  .rm-theme .rm-ord-row[data-shift="#{$n}"] .rm-avatar {
    background: var(--rm-shift-#{$n}-bg);
    color: var(--rm-shift-#{$n}-fg);
  }

  .rm-ord-row[data-shift="#{$n}"] .rm-ord-row__meal b {
    color: var(--rm-shift-#{$n}-fg);
  }
}
</style>
